<!-- safe-html-renderer.component.html -->
<div *ngIf="imageWrapper" linkInterceptor interactiveImageWrapper [innerHTML]="safeHtmlContent" [class]="innerClass"
    [ngClass]="innerNgClass" (click)="onInnerClick()"></div>
<div *ngIf="!imageWrapper" linkInterceptor [innerHTML]="safeHtmlContent" [class]="innerClass" [ngClass]="innerNgClass"
    (click)="onInnerClick()">
</div>